import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { useCallback } from 'preact/hooks';
import { useTranslation } from '../../hooks/use-translation';

interface Props {
	map: google.maps.Map;
}

const MapZoom: FunctionComponent<Props> = ({ map }) => {
	const { t } = useTranslation();
	const zoomIn = useCallback(() => {
		map.setZoom(map.getZoom() + 1);
	}, [map]);

	const zoomOut = useCallback(() => {
		map.setZoom(map.getZoom() - 1);
	}, [map]);
	return (
		<div className="map-zoom">
			<div className="map-zoom-action" onClick={zoomIn}>
				<FontAwesomeIcon icon={faPlus} aria-hidden="false" role="button" aria-label={t('ZOOM_IN')} />
			</div>

			<div className="map-zoom-action" onClick={zoomOut}>
				<FontAwesomeIcon icon={faMinus} aria-hidden="false" role="button" aria-label={t('ZOOM_OUT')} />
			</div>
		</div>
	);
};

export default MapZoom;
